// Utils
import { LOG, transformObjectIntoParam, contains } from '../helpers/utils';
import env from '../helpers/env';
import GZHBase from './GZHBase';

class GZHAuth extends GZHBase {
  constructor() {
    super();
    /**
     * Product ID
     * @type {number}
     */
    this.siteId = 909;
    /**
     * Site Name
     * @type {string}
     */
    this.jornal = 'ZH';
    /**
     * Check environment
     */
    this.env = env();
    /**
     * APi Services domain
     * @type {string}
     * @todo: [CONFIG] Import URL`s from config
     */
    this.domain = this.env !== 'production' ? '//homologacao.clicrbs.com.br' : '//www.clicrbs.com.br';
    this.domainAuth = this.env !== 'production' ? '//api-hlg.clicrbs.com.br' : '//api.clicrbs.com.br';
    /**
     * Api metrics domain
     * @type {string}
     * @todo: [CONFIG] Import URL`s from config
     */
    // this.apiMetricsDomain = this.env === 'production' ? '//api-metric.rbs.com.br' : '//prd_online_metric-api-v2_api.edit-services.rbs.com.br';
    this.apiMetricsDomain = '/api-user';
    /**
     * Api Services endpoints
     * @type {{login: string, catraca: string, update: string, metricsApi: string, facebookLogin: string}}
     */
    this.endpoints = {
      login: '/wrs/api/session',
      loginProxy: '/wrs-proxy/session',
      catraca: '/user/session',
      update: '/wrs/action/update/loadUser',
      // metricsApi: '/api/user/getUserMetrics/',
      metricsApi: '/api/metric/user/info',
      facebookLogin: '/wrs/api/socialmediauser'
    };
    /**
     * Messages object
     * @type {[*]}
     * @private
     */
    this._messages = [
      { key: 'Failed to fetch', message: 'Por favor, tente novamente.', type: 'error' },
      { key: 'AUTH_FAILED', message: 'Por favor, tente novamente.', type: 'error' },
      { key: 'STATUS_USER_DELETED', message: 'Crie seu cadastro clicando <a target="_blank" href="http://www.clicrbs.com.br/wrs/action/update/newUser?site=909">aqui</a>', type: 'error' },
      { key: 'STATUS_USER_NOT_FOUND', message: 'Informe um e-mail ou senha válidos.', type: 'error' },
      { key: 'STATUS_USER_SUSPENDED', message: 'Normalize seu acesso! Ligue para 3218 8200.', type: 'error' },
      { key: 'STATUS_USER_AUTHENTICATED_USER_BLOCKED', message: 'Normalize seu acesso! Ligue para 3218 8200.', type: 'error' },
      { key: 'INVALID_EMAIL', message: 'Sua conta do Facebook precisa ter um e-mail ativo para prosseguir. Crie seu cadastro <a target="_blank" href="http://www.clicrbs.com.br/wrs/action/update/newUser?site=909">aqui</a>.', type: 'fb_error' }
    ];

    /**
     * Remove sub-domain from domain host
     * @type {string}
     */
    this._cookieDomain = window ? window.location.hostname.replace(/^[^.]+\./g, '') : 'clicrbs.com.br';
  }

  /**
   * Login User on WRS services
   * @param user
   * @returns {Promise.<TResult>}
   */
  login(user) {
    const options = {
      ...user,
      site: this.siteId
    };
    const urlSession = `${this.domain}${this.endpoints.login}?${transformObjectIntoParam(options)}`;

    const optionsRequest = { method: 'POST', mode: 'cors' };

    return this.fetch(urlSession, optionsRequest)
      .then((response) => {
        if (this.canUserAuth(response.status)) {
          return this.loginSuccess(response, options);
        }
        throw new Error(response.status);
      })
      .catch(err => this.loginFail(err));
  }

  /**
   * FacebookLogin: Used to login user on wrs with facebook user object
   * @param user
   * @returns {Promise.<TResult>}
   */
  loginFacebook(user) {
    const options = {
      ...user,
      social_media: 'facebook',
      stayLogged: '1'
    };

    const optionsRequest = {
      method: 'POST',
      body: transformObjectIntoParam(options),
      headers: new Headers({ //eslint-disable-line
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      })
    };

    return this.fetch(`${this.domain}${this.endpoints.facebookLogin}`, optionsRequest)
      .then((response) => {
        if (this.canUserAuth(response.status)) {
          return this.loginSuccess(response, options);
        }
        throw new Error(response.status);
      })
      .catch(err => this.loginFail(err));
  }

  /**
   * Get user info, from token if exists or METRICS API
   * @param token
   * @returns {*}
   * @todo: Refatorar o envio do token para não precisar encodar multiplas vezes, hoje api espera ele duplamente encodado
   */
  getUserInfo(token, data = {}) {
    LOG('GZHAuth', 'getUserInfo()', token);
    const TOKEN = encodeURIComponent(token);// this.encodeToken(token);
    const params = {
      product: 'ZHDIGITAL'
    };
    // const urlMetricsApi = `${this.apiMetricsDomain}${this.endpoints.metricsApi}${TOKEN}/${this.jornal}?${transformObjectIntoParam(params)}`;
    const urlMetricsApi = `${this.apiMetricsDomain}${this.endpoints.metricsApi}?${transformObjectIntoParam(params)}`;
    const gzhUserInfoToken = this.getUserInfoFromCookie();

    if (!gzhUserInfoToken) {
      // return this.fallbackGetUserInfo(TOKEN, data);
      return this.fetch(urlMetricsApi, { headers: new Headers({ 'token-wrs': TOKEN }) }) //eslint-disable-line
        .then((response) => {
          LOG('GZHAuth', 'getUserInfo()', 'response', response);
          /**
           * Verify if service return some error on htt status 200;
           */
          if (!response.data) {
            return this.fallbackGetUserInfo(TOKEN, data);
          }
          return this.translateUserInfosV2(response.data);
        })
        .then((response) => {
          const user = { ...response, data };
          this.setCookie('gzhuserinfo', JSON.stringify(user), { expires: this.getExpirationDate(1) });
          return user;
        })
        .catch((err) => {
          LOG('GZHAuth', 'getUserInfo()', 'catch', err);
          return this.fallbackGetUserInfo(TOKEN, data);
        });
    }
    return gzhUserInfoToken;
  }

  /**
   * Fallback service to retrieve user info, is called when Metrics api fails
   * In case of this service don`t return a 200 status header, we keep the user logged in and use a default identification
   * @param token
   * @param data
   * @returns {*}
   */
  async fallbackGetUserInfo(token, data) {
    LOG('GZHAuth', 'fallbackGetUserInfo()', token);
    let url;
    let link;
    let userName;
    let dataLinks = data;

    if (!('_links' in data)) { // case dont have _links, revalidate login.
      try {
        dataLinks = await this.revalidateLogin(token);
        LOG('dataLinks', dataLinks);
      } catch (error) {
        return this.abortLogin(error);
      }
    }

    try {
      link = this.getLinks('user', dataLinks._links);
      userName = link ? link.split('/').pop() : '';
      url = `${this.domain}${link}`;
    } catch (err) {
      LOG('GZHAuth', 'fallbackGetUserInfo', 'ERROR IN LINKS OBJECT', err);
      // return this.loginFail(err);
    }

    return this.fetch(url)
      .then((response) => {
        LOG('GZHAuth', 'fallbackGetUserInfo() fetch', response);
        const user = {
          initials: this.getUserInitials(response.givenName, response.familyName ? response.familyName : '', response.userName),
          email: response.email,
          usuario: response.userName,
          nome: response.givenName,
          sobrenome: response.familyName ? response.familyName : '',
          tipoPessoa: response.legalEntity === 'F' ? 'Física' : 'Jurídica',
          assinante: null,
          assinatura: null,
          clube: null
        };
        return this.translateUserInfos(user);
      })
      .then((response) => {
        LOG('GZHAuth', 'fallbackGetUserInfo() success', token);
        const user = { ...response, data, useFallback: true };
        this.setCookie('gzhuserinfo', JSON.stringify(user), { expires: this.getExpirationDate(1) });
        return user;
      })
      .catch((err) => {
        LOG('GZHAuth', 'fallbackGetUserInfo() error', err);
        const user = {
          usuario: userName || 'Visitante',
          email: '',
          nome: userName || 'Visitante',
          sobrenome: '',
          tipoPessoa: 'Não identificado',
          assinante: null,
          assinatura: null,
          clube: null
        };
        /**
         * When this service fails, we already have user token to keep the access alive, so create a temporary
         * cookie with default data, this allow to user stay logged and we request this services later again
         * The Cookie is set to 1 hour
         */
        return this.translateUserInfos(user).then((successUserTranslated) => {
          this.setCookie('apauserinfo', JSON.stringify(successUserTranslated), { expires: this.getExpirationDate(1) });
          return successUserTranslated;
        });
      });
  }

  revalidateLogin(token) {
    const options = {
      token: encodeURIComponent(token),
      product: this.siteId
    };
    const urlSession = `${this.domainAuth}${this.endpoints.loginProxy}?${transformObjectIntoParam(options)}`;

    const optionsRequest = { method: 'POST', mode: 'cors' };

    return this.fetch(urlSession, optionsRequest)
      .then((response) => {
        if (this.canUserAuth(response.status)) {
          return this.loginSuccess(response, options);
        }
        throw new Error(response.status);
      })
      .catch(err => this.loginFail(err));
  }

  /**
   * Called after login success
   * @param response
   * @param options
   * @returns {*}
   */
  loginSuccess(response, options) {
    const { token } = response;
    // Decode token
    response.token = decodeURIComponent(token);
    LOG('GZHAuth', 'decoding token', response.token);

    LOG('GZHAuth', 'loginSuccess()', response, options);
    this.setToken(response.token, { expires: this.getExpirationDate() });
    // when set token wrs, clear user info to be updated and prevent conflicts from user data
    this.deleteCookie('apauserinfo');
    return response;
  }

  /**
   * Called when login fails
   * @param err Error
   * @returns {*}
   */
  loginFail(err) {
    LOG('GZHAuth', 'loginFail()', err);
    return this.getMessages(err.message);
  }

  /**
   * Called when revalidateLogin fails
   * @param err Error
   * @returns {*}
   */
  async abortLogin(err) {
    LOG('GZHAuth', 'abortLogin()', err);
    const logout = await this.logout();
    LOG('GZHAuth', 'logout()', logout);
    return this.getMessages(err.message);
  }

  /**
   * Parse response data to find a key:value pair
   * @param rel
   * @param _links
   * @returns {null}
   */
  getLinks(rel, _links) {
    LOG('getLinks', rel, _links);
    for (let i = 0, linksLength = _links ? _links.length : 0; i < linksLength; i++) {
      if (_links[i].rel === rel) {
        return _links[i].href;
      }
    }
    throw new Error('Cant find user link');
  }

  /**
   * Load user info from apauserinfo cookie
   * @returns {*}
   */
  getUserInfoFromCookie() {
    return this.getCookie('apauserinfo');
  }

  /**
   * Check if user is Authenticated on WRS
   * @returns {boolean}
   */
  isAuthenticated() {
    return this.getToken() || false;
  }

  /**
   * Return user info object
   * @param user
   * @returns {Promise}
   */
  translateUserInfos(user) {
    return new Promise((resolve, reject) => {
      try {
        const DATA = {
          initials: this.getUserInitials(user.nome, user.sobrenome, user.usuario),
          userName: user.usuario,
          gender: '',
          personType: user.tipoPessoa,
          email: user.email,
          status: 'Activated',
          name: user.nome,
          firstName: user.nome ? user.nome.split(' ').shift() : 'Visitante',
          cpf: '',
          lastName: user.sobrenome,
          /**
           * Abstract verification if user is subscriber
           */
          digitalId: '',
          isEmployee: false,
          hasClube: false,
          isSubscriber: user.assinante === true,
          subscriptions: [],
          hasSubscriptions: false
        };
        LOG('translateUserInfos', DATA);
        resolve(DATA);
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Return user info object
   * @param user
   * @returns {Promise}
   */
  translateUserInfosV2(data) {
    const { user, subscriptions } = data;
    return new Promise((resolve, reject) => {
      try {
        const DATA = {
          ...user,
          initials: this.getUserInitials(user.firstName, user.lastName, user.userName),
          personType: user.personType === 'J' ? 'Jurídica' : 'Física',
          name: [user.firstName, user.lastName].join(' '),
          subscriptions,
          firstName: user.firstName ? user.firstName.split(' ').shift() : 'Visitante',
          digitalId: user.isEmployee ? 'funcionário' : this.getDigitalId(subscriptions)
        };
        LOG('translateUserInfosV2', DATA);
        resolve(DATA);
      } catch (error) {
        reject(error);
      }
    });
  }
  getDigitalId(subscriptions = []) {
    if (!subscriptions) {
      return 'não assinante';
    }
    if (!subscriptions.length) {
      return 'não assinante';
    }
    return subscriptions[0].additionalType;
  }
  /**
   * Returns first letter of words to present on front
   * @param userFirstName
   * @param userLastName
   * @param userNameArgs
   * @returns {string}
   */
  getUserInitials(userFirstName = '', userLastName = '', userNameArgs = '') {
    let initials = '';
    const name = userFirstName || '';
    const lastName = userLastName || '';
    const userName = userNameArgs || '';

    if (name !== '') {
      if (lastName !== '') {
        initials = `${name.trim().substring(0, 1)}${lastName.trim().substring(0, 1)}`;
      } else {
        initials = name.trim().substring(0, 2);
      }
    } else if (userName !== '') {
      initials = userName.trim().substring(0, 2);
    }

    return initials.toUpperCase();
  }

  /**
   * Logout user
   * Remove all cookies set
   * @returns {Promise}
   */
  logout() {
    LOG('GZHAuth', 'logout()');
    return new Promise((resolve, reject) => {
      this.deleteCookie('wrs');
      this.deleteCookie('apauserinfo');
      if (!this.getToken()) {
        resolve({ authenticated: false });
      } else {
        reject({ authenticated: false }); //eslint-disable-line
      }
    });
  }
  /**
   * An array of user status authentication to validate
   * Is used to prevent that users with wrong status can login, api service don`t returns this in a good way
   * @returns {[string]}
   */
  possibleAuthStatus() {
    return [
      'STATUS_USER_AUTHENTICATED',
      'STATUS_USER_AUTHENTICATED_NOT_ACTIVE',
      'STATUS_USER_AUTHENTICATED_USER_ACTIVE',
      'STATUS_USER_AUTHENTICATED_DUPLICATED_ACCOUNT',
      'STATUS_USER_AUTHENTICATED_PRODUCT_FIELD_REQUIRED'
    ];
  }

  /**
   * Check if user status is in authorization status
   * @param status
   */
  canUserAuth(status) {
    return contains(this.possibleAuthStatus(), status);
  }
}
export default GZHAuth;
